import React from 'react';
import { connect } from 'react-redux';
import { withLocalize } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { writeWarn } from '../../common/logger';
import { domainActions } from '../../../store/domainStore';
import { getSubjectDataSchema } from '../validations/subjectDataSchema';
import { capitalize, isNullOrUndefined } from '../../../store/storeFunctions';
import { repiActions, dataCorrectionType, dataCorrectionSection, repiDomain  } from '../../../store/repiStore';
import RepiDataCorrectionTable from './dataCorrection/repiDataCorrectionTable';
import RepiDataCorrectionButtons from './dataCorrection/repiDataCorrectionButtons';
import RepiDataCorrectionSection from './dataCorrection/repiDataCorrectionSection';
import RepiDataCorrectionTableColumn from './dataCorrection/repiDataCorrectionTableColumn';

import '../repi.scss';

const PAGE_LIMIT = 10;

class SubjectDataCorrection extends React.Component {
    render() {
        if (isNullOrUndefined(this.props.data))
            return null;

        return (
            <div>
                <RepiDataCorrectionSection isBold
                    key={dataCorrectionSection.identification}
                    name={this.props.translate("Repi.Report.DataCorrection.HistoryIdentification")}
                    rightContent={this.renderSectionButtons(dataCorrectionSection.identification)}
                >
                    <RepiDataCorrectionTable idKey="id"
                        sectionId={dataCorrectionSection.identification}
                        data={this.props.data[dataCorrectionSection.identification]}
                        pendingData={this.props.data[this.getInsertedForSection(dataCorrectionSection.identification)]}
                        subjectId={this.props.data.subjectId}
                        validationSchema={getSubjectDataSchema(dataCorrectionSection.identification, this.props.translate, this.props.data.subjectType)}
                        pageLimit={PAGE_LIMIT}
                    >
                        <RepiDataCorrectionTableColumn name="name" type={dataCorrectionType.string} label="Repi.Report.Other.Name" />
                        <RepiDataCorrectionTableColumn name="surname" type={dataCorrectionType.string} label="Repi.Report.Other.Surname" />
                        <RepiDataCorrectionTableColumn name="companyName" type={dataCorrectionType.string} label="Repi.Report.Other.CompanyName" />
                        <RepiDataCorrectionTableColumn name="birthDate" type={dataCorrectionType.date} label="Repi.Report.Other.BirthDate" />
                        <RepiDataCorrectionTableColumn name="pin" type={dataCorrectionType.string} label="Repi.Report.Other.BirthNumber" />
                        <RepiDataCorrectionTableColumn name="companyId" type={dataCorrectionType.string} label="Repi.Report.Other.CompanyId" />
                        <RepiDataCorrectionTableColumn name="alias" type={dataCorrectionType.string} label="Repi.Report.Other.Alias" />
                        <RepiDataCorrectionTableColumn name="flagActual" type={dataCorrectionType.bool} label="Repi.Report.Other.Actual" />
                        <RepiDataCorrectionTableColumn name="isIdentification" type={dataCorrectionType.bool} label="Repi.Report.Other.Primary" />
                        <RepiDataCorrectionTableColumn name="isAnonymized" type={dataCorrectionType.bool} label="Repi.Report.Other.Anonymized" />
                    </RepiDataCorrectionTable>
                </RepiDataCorrectionSection>
                <RepiDataCorrectionSection isBold
                    key={dataCorrectionSection.addresses}
                    name={this.props.translate("Repi.Report.DataCorrection.HistoryAddress")}
                    rightContent={this.renderSectionButtons(dataCorrectionSection.addresses)}
                >
                    <RepiDataCorrectionTable idKey="addressId"
                        sectionId={dataCorrectionSection.addresses}
                        data={this.props.data[dataCorrectionSection.addresses]}
                        pendingData={this.props.data[this.getInsertedForSection(dataCorrectionSection.addresses)]}
                        subjectId={this.props.data.subjectId}
                        validationSchema={getSubjectDataSchema(dataCorrectionSection.addresses, this.props.translate, null)}
                        pageLimit={PAGE_LIMIT}
                    >
                        <RepiDataCorrectionTableColumn name="street" type={dataCorrectionType.string} label="Repi.Report.Other.Street" />
                        <RepiDataCorrectionTableColumn name="houseNo" type={dataCorrectionType.string} label="Repi.Report.Other.HouseNumber" />
                        <RepiDataCorrectionTableColumn name="city" type={dataCorrectionType.string} label="Repi.Report.Other.City" />
                        <RepiDataCorrectionTableColumn name="zip" type={dataCorrectionType.string} label="Repi.Report.Other.Zip" />
                        <RepiDataCorrectionTableColumn name="countryCode" type={dataCorrectionType.list} label="Repi.Report.Other.Country" domainKey={repiDomain.countries} />
                        <RepiDataCorrectionTableColumn name="addressType" type={dataCorrectionType.list} label="Repi.Report.Other.Address" domainKey={repiDomain.addresses} />
                        <RepiDataCorrectionTableColumn name="startDate" type={dataCorrectionType.date} label="Repi.Report.Other.StartDate" />
                        <RepiDataCorrectionTableColumn name="endDate" type={dataCorrectionType.date} label="Repi.Report.Other.EndDate" noMaxDate />
                        <RepiDataCorrectionTableColumn name="flagActual" type={dataCorrectionType.bool} label="Repi.Report.Other.Actual" />
                        <RepiDataCorrectionTableColumn name="isAnonymized" type={dataCorrectionType.bool} label="Repi.Report.Other.Anonymized" />
                    </RepiDataCorrectionTable>
                </RepiDataCorrectionSection>
                <RepiDataCorrectionSection isBold
                    key={dataCorrectionSection.contacts}
                    name={this.props.translate("Repi.Report.DataCorrection.HistoryContacts")}
                    rightContent={this.renderSectionButtons(dataCorrectionSection.contacts)}
                >
                    <RepiDataCorrectionTable idKey="contactId"
                        sectionId={dataCorrectionSection.contacts}
                        data={this.props.data[dataCorrectionSection.contacts]}
                        pendingData={this.props.data[this.getInsertedForSection(dataCorrectionSection.contacts)]}
                        subjectId={this.props.data.subjectId}
                        validationSchema={getSubjectDataSchema(dataCorrectionSection.contacts, this.props.translate, null)}
                        pageLimit={PAGE_LIMIT}
                    >
                        <RepiDataCorrectionTableColumn name="value" type={dataCorrectionType.string} label="Repi.Report.Other.Value" />
                        <RepiDataCorrectionTableColumn name="contactType" type={dataCorrectionType.list} label="Repi.Report.Other.Type" domainKey={repiDomain.contacts} />
                        <RepiDataCorrectionTableColumn name="startDate" type={dataCorrectionType.date} label="Repi.Report.Other.StartDate" />
                        <RepiDataCorrectionTableColumn name="endDate" type={dataCorrectionType.date} label="Repi.Report.Other.EndDate" noMaxDate  />
                        <RepiDataCorrectionTableColumn name="flagActual" type={dataCorrectionType.bool} label="Repi.Report.Other.Actual" />
                        <RepiDataCorrectionTableColumn name="isAnonymized" type={dataCorrectionType.bool} label="Repi.Report.Other.Anonymized" />
                    </RepiDataCorrectionTable>
                </RepiDataCorrectionSection>
                <RepiDataCorrectionSection isBold
                    key={dataCorrectionSection.documents}
                    name={this.props.translate("Repi.Report.DataCorrection.HistoryDocuments")}
                    rightContent={this.renderSectionButtons(dataCorrectionSection.documents)}
                >
                    <RepiDataCorrectionTable idKey="documentId"
                        sectionId={dataCorrectionSection.documents}
                        data={this.props.data[dataCorrectionSection.documents]}
                        pendingData={this.props.data[this.getInsertedForSection(dataCorrectionSection.documents)]}
                        subjectId={this.props.data.subjectId}
                        validationSchema={getSubjectDataSchema(dataCorrectionSection.documents, this.props.translate, null)}
                        pageLimit={PAGE_LIMIT}
                    >
                        <RepiDataCorrectionTableColumn name="value" type={dataCorrectionType.string} label="Repi.Report.Other.Value" />
                        <RepiDataCorrectionTableColumn name="documentType" type={dataCorrectionType.list} label="Repi.Report.Other.Type" domainKey={repiDomain.documents} />
                        <RepiDataCorrectionTableColumn name="issueDate" type={dataCorrectionType.date} label="Repi.Report.Other.IssueDate" />
                        <RepiDataCorrectionTableColumn name="expirationDate" type={dataCorrectionType.date} label="Repi.Report.Other.ExpireDate" noMaxDate  />
                        <RepiDataCorrectionTableColumn name="countryCode" type={dataCorrectionType.list} label="Repi.Report.Other.Country" domainKey={repiDomain.countries} />
                        <RepiDataCorrectionTableColumn name="startDate" type={dataCorrectionType.date} label="Repi.Report.Other.StartDate" />
                        <RepiDataCorrectionTableColumn name="endDate" type={dataCorrectionType.date} label="Repi.Report.Other.EndDate" noMaxDate />
                        <RepiDataCorrectionTableColumn name="flagActual" type={dataCorrectionType.bool} label="Repi.Report.Other.Actual" />
                        <RepiDataCorrectionTableColumn name="isAnonymized" type={dataCorrectionType.bool} label="Repi.Report.Other.Anonymized" />
                    </RepiDataCorrectionTable>
                </RepiDataCorrectionSection>
            </div>
        );
    }

    componentDidMount() {
        this.props.ensureDomainData(repiDomain.countries);
        this.props.ensureDomainData(repiDomain.addresses);
        this.props.ensureDomainData(repiDomain.documents);
        this.props.ensureDomainData(repiDomain.contacts);
    }

    renderSectionButtons = (sectionId) => {
        return (
            <RepiDataCorrectionButtons small
                onInsert={(e) => this.onButtonClick(e, sectionId, "insert")}
                onSave={(e) => this.onButtonClick(e, sectionId, "save")}
                onCancel={(e) => this.onButtonClick(e, sectionId, "cancel")}
            />
        );
    }

    onButtonClick = (e, sectionId, action) => {
        if (!isNullOrUndefined(e))
            e.stopPropagation();

        const button = document.querySelector(`#btn-${sectionId}-${action}`);
        if (!isNullOrUndefined(button))
            button.click();
        else
            writeWarn(`No button #btn-${sectionId}-${action} in document!`)
    }

    getInsertedForSection = (section) => `inserted${capitalize(section)}`;
}

export default connect(
    state => state.domain,
    dispatch => bindActionCreators({...repiActions, ...domainActions}, dispatch)
)(withLocalize(SubjectDataCorrection));
